import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import {
  DropdownButton, MenuItem,
} from 'react-bootstrap';
import { each, find, indexOf } from 'lodash';
import RequiredOpportunityOwnerSignature from '../../../../components/request-signature/RequireOpportunityOwnerSignature';
import { getOpportunityOwnerSignature } from '../../../../components/request-signature/reducer';
import {
  getUser,
  getIsAdmin,
  getIsSuperAdmin,
  getIsPIUser,
  getUserCurrentOrganization,
  getIsOrganizationManager,
  getIsOrganizationAdmin,
} from '../../../Auth/AuthReducer';

class EditSenderField extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.selectSender = this.selectSender.bind(this);
  }

  selectSender(selectedSender) {
    let email = null;
    if (selectedSender) {
      email = selectedSender.is_collector ? null : selectedSender.id;
    }
    this.props.onSelectEmail(email);
  }

  renderSender(sender) {
    const star = sender.is_collector ? <span className="text-warning"><Fa name="star" /> </span> : null;

    return (
      <span>{star}{sender.name} <code>{sender.email}</code></span>
    );
  }

  componentDidMount() {
    const activeSender = this.getActiveSender(this.getList());
    if (activeSender) {
      this.selectSender(activeSender);
    }
  }

  getList() {
    const {
      verified, owners, canManage, dynamicSenders,
      isAccount, collectorSignatures, authSignature,
    } = this.props;
    const list = [];
    if (owners.length) {
      list.push({
        label: isAccount ? 'Account Owners:' : 'Opportunity Owner:',
        isHeader: true,
        id: 'owners',
      });
      each(owners, (owner) => {
        list.push(owner);
      });
    }


    if (collectorSignatures && collectorSignatures.length > 0) {
      list.push({
        isHeader: true,
        label: 'Survey Colector:',
        id: 'collector',
      });

      each(collectorSignatures, (collectorSignature) => {
        list.push(collectorSignature);
      });
    }

    if (dynamicSenders.length) {
      list.push({
        label: 'Dynamic Senders:',
        isHeader: true,
        id: 'dynamic',
      });
      each(dynamicSenders, (owner) => {
        list.push(owner);
      });
    }

    
    if (canManage && verified && authSignature) {
      list.push({
        label: 'You',
        isHeader: true,
        id: 'you',
      });
      list.push({
        ...authSignature,
        isUser: true,
      });
    }
    return list;
  }

  getActiveSender(list) {
    const { survey, selectedEmail } = this.props;
    const activeSender = selectedEmail ? find(list, { id: selectedEmail }) || find(list, { email: selectedEmail }) : find(list, { email: survey.collector_email });
    return activeSender;
  }

  renderContent() {
    const {
      survey, submitting,
    } = this.props;

    const useSalesRepsEmailFirst = survey.is_sales_rep_first === true;
    const list = this.getList();
    const activeSender = this.getActiveSender(list);


    return (
      <div>
        <DropdownButton
          onSelect={this.selectSender}
          disabled={submitting}
          title={activeSender ? this.renderSender(activeSender) : 'Select Email'}
          id="sender-selector"
        >
          {list.map((menu) => {
            if (menu.isHeader) {
              return (
                <MenuItem header key={menu.id}>
                  {menu.label}
                </MenuItem>
              );
            }
            return (
              <MenuItem
                active={activeSender ? menu.id === activeSender.id : false}
                key={menu.id}
                disabled={menu.disabled === true}
                eventKey={menu}
              >
                {this.renderSender(menu)}
              </MenuItem>
            );
          })}
        </DropdownButton>

        {activeSender && activeSender.isCollector && useSalesRepsEmailFirst &&
          <div className="text-warning" style={{ marginTop: 10 }}>
            Please notice that this collector sender information is set to <strong>Sales Rep First</strong>, meaning it will use the the opportunity&rsquo;s sales reps email when available.
          </div>
        }

        {activeSender && activeSender.source === 'dynamicSender' && activeSender.automation_qualidfied === false &&
          <div className="text-warning" style={{ marginTop: 10 }}>
            <Fa name="exclamation-triangle" /> Please notice that this dynamic sender does not match the trigger conditions of any automation group.
          </div>
        }
      </div>
    );
  }

  render() {
    const { isAccount, survey } = this.props;
    const hasSurvey = survey && survey.id;
    const props = {};
    if (hasSurvey) {
      if (isAccount) {
        props.account_id = survey.object_id;
      } else {
        props.opportunity_id = survey.object_id;
      }
    }
    return (
      <RequiredOpportunityOwnerSignature
        isAccount={isAccount}
        onCancel={this.props.onCancel}
        initiative={{
          id: survey.program_id,
          client_id: survey.client_id,
          defaultCollector: {
            collector_id: survey.collector_id,
          },
        }}
        object={survey.object}
      >
        {this.renderContent()}
      </RequiredOpportunityOwnerSignature>
    );
  }
}

EditSenderField.propTypes = {
  survey: PropTypes.shape({
    collector_id: PropTypes.string,
    object_id: PropTypes.string,
    client_id: PropTypes.string,
    program_id: PropTypes.string,
    is_sales_rep_first: PropTypes.bool,
    collector_email: PropTypes.string,
    email_from: PropTypes.shape({
      email: PropTypes.string,
    }),
  }),
  onCancel: PropTypes.func,
  isAccount: PropTypes.bool,
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }).isRequired,
  verified: PropTypes.bool,
  owners: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
    id: PropTypes.string,
  })),
  collectorSignatures: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
    id: PropTypes.string,
  })),
  dynamicSenders: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
    id: PropTypes.string,
    source: PropTypes.string,
    automation_qualidfied: PropTypes.bool,
  })),
  onSelectEmail: PropTypes.func,
  selectedEmail: PropTypes.string,
  submitting: PropTypes.bool,
  canManage: PropTypes.bool,
  authSignature: PropTypes.shape({}),

};
EditSenderField.defaultProps = {
  survey: null,
  isAccount: false,
  verified: false,
  owners: [],
  collectorSignatures: [],
  dynamicSenders: [],
  onCancel: () => {},
  onSelectEmail: () => {},
  selectedEmail: null,
  authSignature: null,
  submitting: false,
  canManage: false,
};
EditSenderField.contextTypes = {
};

function mapStateToProps(state, ownProps) {
  let info = {};
  if (ownProps.survey) {
    const id = ownProps.isAccount ? ownProps.survey.object.account_id : ownProps.survey.object.opportunity_id;
    info = getOpportunityOwnerSignature(state, ownProps.survey.client_id, ownProps.survey.program_id, id, ownProps.survey.collector_id);
  }
  const isAdmin = getIsAdmin(state);
  const isSuperAdmin = getIsSuperAdmin(state);
  const isPIUser = getIsPIUser(state);
  const userCurrentOrganization = getUserCurrentOrganization(state);
  const isOrganizationManager = getIsOrganizationManager(state);
  const isOrganizationAdmin = getIsOrganizationAdmin(state);

  const user = getUser(state);
  let canManage = isOrganizationManager || isOrganizationAdmin;
  if (isAdmin || isSuperAdmin) {
    canManage = true;
  } else if (isPIUser && user && userCurrentOrganization && indexOf(user.organization__ids, userCurrentOrganization._id) >= 0) {
    canManage = true;
  }

  return {
    user: getUser(state),
    verified: info.isMyEmailConfirm,
    owners: info.owners || [],
    authSignature: info.authSignature || info.auth,
    collectorSignatures: info.collectors || [],
    dynamicSenders	: info.dynamicSenders	 || [],
    canManage,
  };
}

export default connect(mapStateToProps)(EditSenderField);
